import * as React from 'react';
import CardContainer from '../../../components/CardContainer';
import { Spin, Typography } from 'antd';
import Devider from '../../../components/Devider';
import StepperFooter from '../../../components/StepperFooter';
import LogoUploader from './LogoUploader';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import DesignModel from '../models/DesignModel';
import { LoadingOutlined, StarFilled } from '@ant-design/icons';
import { WIZARD_STEPS } from '../../wizard-steps-description';
import { STEP_SITE_BUILDER, STEP_PREPARING_WEBSITE } from '../../steps-definitions';
import Step from '../../SiteBuilder/Step';
import StepperModel from '../../../models/StepperModel';
import { H1 } from '../../../components/ui/Typography';
import HelpBoxCompanionModel from '../../../models/HelpBoxCompanionModel';
import generateIcon from '../../../assets/generate-preview-icon.svg';
import { AnimatePresence, motion } from 'framer-motion';
import {
  fadeInUpVariants,
  staggerContainerVariants,
} from '../../../components/animations/StepAnimations';

const { Title } = Typography;

interface FCProps { }

const Index: React.FC<FCProps> = observer(({ }) => {
  const [loadingNextStep, setLoadingNextStep] = React.useState(false);
  const { t } = useTranslation();

  React.useEffect(() => {
    HelpBoxCompanionModel.setDisplayHelpBox(false);
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={staggerContainerVariants}
      >
        <CardContainer>
          <motion.div variants={fadeInUpVariants}>
            <H1 style={{ fontWeight: 400 }}>
              {t('Almost done!')}
              <strong> {t('We only need your logo')}</strong>
            </H1>
          </motion.div>
          <div className="flex flex-col">
            <div className="relative">
              <motion.div variants={fadeInUpVariants} className="sm:text-center">
                {DesignModel.foundLogos.length === 0 &&
                  DesignModel.uploadedLogos.length === 0 &&
                  DesignModel.loadingLogo === false && (
                    <div className="text-red-500 mb-4">
                      {t(
                        'No logo found on the website. Please upload your logo!'
                      )}
                    </div>
                  )}
                {DesignModel.loadingLogo && (
                  <div className="h-[100px] w-full flex items-center align-middle">
                    <Spin
                      indicator={
                        <LoadingOutlined style={{ fontSize: 24 }} spin />
                      }
                    />
                  </div>
                )}
                <LogoUploader
                  selectedLogo={DesignModel.selectedLogo}
                  onChange={(file) => {
                    DesignModel.changeSelectedLogo(file);
                  }}
                />
              </motion.div>
            </div>
            <motion.div variants={fadeInUpVariants}>
              <StepperFooter
                buttonId="logo-preview-generate"
                buttonGaEvent="logo-preview-generate"
                loading={loadingNextStep}
                buttonText={t('Generate website preview')}
                icon={
                  <img
                    src={generateIcon}
                    alt="Generate Icon"
                    style={{ width: 15, height: 15 }}
                  />
                }
                onFormsValidationSuccess={async (_, nextStep) => {
                  setLoadingNextStep(true);

                  try {
                    // store information about this step
                    DesignModel.designModelWizardData.setFormData({
                      logo: DesignModel.selectedLogo?.getFileUrl() || null,
                      font_main: DesignModel.selectedFontData?.mainFontFamily,
                      font_display: DesignModel.selectedFontData?.displayFontFamily,
                    });

                    StepperModel.changeStep(STEP_PREPARING_WEBSITE);
                  } catch (error) {
                    console.error('Error while preparing next step:', error);
                  } finally {
                    setLoadingNextStep(false);
                  }
                }}
              />
            </motion.div>
          </div>
        </CardContainer>
      </motion.div>
    </AnimatePresence>
  );
});

export default Index;
